import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import character1 from '../../assets/images/betshop-baccarat/character-1.png';
import character2 from '../../assets/images/betshop-baccarat/character-2.png';

export const BetShopActionPanel = observer(() => {
  const t = useTranslation();

  return (
    <div className='bb-actions-holder'>
      <div className='bb-actions'>
        <div className='bb-action'>
          <div className='bb-action-pair sm blue'>
            <p>
              <span className='bb-action-pair-letter'>{t('P')}</span>
              <span>{t('PAIR')}</span>
            </p>
            <span>x12</span>
          </div>
        </div>
        <div className='bb-action'>
          <div className='bb-action-player lg blue'>
            <div className='bb-sign sm blue-sign rotated-l'>
              <div className='bb-sign-inside'>
                <img src={character1} alt='' />
              </div>
            </div>
            <p>{t('PLAYER')}</p>
            <span>x2</span>
          </div>
        </div>
        <div className='bb-action'>
          <div className='bb-action-tie'>
            <p>{t('TIE')}</p>
            <span>x9</span>
          </div>
        </div>
        <div className='bb-action'>
          <div className='bb-action-player lg red'>
            <div className='bb-sign sm red-sign rotated-r'>
              <div className='bb-sign-inside'>
                <img src={character2} alt='' />
              </div>
            </div>
            <p>{t('BANKER')}</p>
            <span>x1.95</span>
          </div>
        </div>
        <div className='bb-action'>
          <div className='bb-action-pair sm red'>
            <p>
              <span className='bb-action-pair-letter'>{t('B')}</span>
              <span>{t('PAIR')}</span>
            </p>
            <span>x12</span>
          </div>
        </div>
      </div>
    </div>
  );
});
